import { Box } from '@ltvco/refresh-lib/theme';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { ChatLayout, ChatPage } from 'components/ChatBV/components';
import { ChatLayoutProvider, ChatProvider } from 'components/ChatBV/context';
import { NotFound } from 'routes';
import { RecentReportsContainer } from 'routes/Dashboard/RecentReports/components/RecentReportsContainer';

import { AccountPage } from './AccountPage/AccountPage';
import { AccountPageV2 } from './AccountPage/AccountPageV2';
import { UpgradePlanPage } from './UpgradePlanPage';

export interface FooterProps {
  footerLinks: Array<{
    title: string;
    links: Array<{ text: string; href: string; onClick?: () => void }>;
  }>;
  libVersion: ReactElement;
  hasMobileApps: boolean;
  userInReactivationRedesignTest: boolean;
}

interface ChatBVContainerProps {
  footerProps: FooterProps;
  onCancelConfirmCancelModal: () => void;
  openConfirmCancelModal: () => void;
  onLogout: () => void;
  contactUsHandler: () => void;
}

export const ChatBVContainer = ({
  footerProps,
  onCancelConfirmCancelModal,
  openConfirmCancelModal,
  onLogout,
  contactUsHandler,
}: ChatBVContainerProps) => {
  const isInRedesignVariation = useFeatureIsOn('prop-3688');

  return (
    <Box sx={{ height: '100vh', width: '100%' }}>
      <ChatProvider>
        <ChatLayoutProvider>
          <Routes>
            <Route path="/*" element={<ChatLayout onLogout={onLogout} />}>
              <Route index element={<Navigate to="/chatbv/chat" replace />} />
              <Route path="chat" element={<ChatPage />} />
              <Route path="chat/library" element={<RecentReportsContainer />} />
              <Route
                path="chat/conversation/:contextId?"
                element={<ChatPage />}
              />
              <Route path="upgrade/plan" element={<UpgradePlanPage />} />
              <Route
                path="account"
                element={
                  isInRedesignVariation ? (
                    <AccountPageV2 />
                  ) : (
                    <AccountPage
                      footerProps={footerProps}
                      onCancelConfirmCancelModal={onCancelConfirmCancelModal}
                      openConfirmCancelModal={openConfirmCancelModal}
                      onLogout={onLogout}
                      contactUsHandler={contactUsHandler}
                    />
                  )
                }
              />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </ChatLayoutProvider>
      </ChatProvider>
    </Box>
  );
};
